import _ from "@lodash";
import XAPPService from 'app/Core/services/XAPPService';
export const GET_CIDADE = '[CIDADE APP] GET CIDADE';
export const CIDADE_WARNING = '[CIDADE APP] CIDADE WARNING';
export const CIDADE_INFO = '[CIDADE APP] CIDADE INFO';
export const ERROR_CIDADE = '[CIDADE APP] CIDADE ERROR';

export function list(_AAction, _AParams, _AFilter = null, _ACallback = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappLookupActionFactory("Cidade", AActions, AConditionsAND, AConditionsOR)

        XAPPService.XappLookupAction(AActions, _AParams)
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_CIDADE,
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data) : "",
                    })
                ]);
                if (!_.isNull(_ACallback)) {
                    _ACallback();
                }
            }
            );
    };
}

export function clearReducer() {
    return {
        type: GET_CIDADE,
        data: null,
        pagina: 1,
    }
}